module.exports = __webpack_public_path__ + "static/img/Ryan-Papenhuyzen.c50d422.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ryan-Papenhuyzen.jpg
// module id = pzD+
// module chunks = 0